import {useQuery} from '@tanstack/react-query'
import {useContentstack} from '../../context/contentstack'
import {getEntryByTitle} from '../api/contentstack/sdk/entry'
import useMultiSite from '@salesforce/retail-react-app/app/hooks/use-multi-site'

/**
 * Hook to fetch all footer entries from contentstack
 */
export const useGetFooter = () => {
    const {stack} = useContentstack()
    const {locale} = useMultiSite()

    const getFooterRes = async () => {
        const response = await getEntryByTitle({
            stack,
            contentTypeUid: 'footer',
            title: 'FooterGroup',
            referenceFieldPath: ['footer_content.footer_reference_components'],
            locale: locale.alias,
        })
        return response[0]
    }

    return useQuery(['contentstackGetFooter', 'footer'], () => getFooterRes())
}
